import React from 'react';

import { defaultTo, prop } from 'ramda';

import play from '../../../images/blue_play_icon.svg';

import { FOHImage } from '../../ingredients';

export const FOHBluePlayIcon = (props: any) => (
  <FOHImage
    source={{ uri: play }}
    style={{ width: 21, height: 24, ...defaultTo({}, prop('style', props)) }}
  />
);
